import { convertKeyToDefaultKeyObject, baseKey } from './key-transforms';
import { convertInputBufferToString } from './convert-input-buffer-to-string';

const hotkeyEqualityAttributes = Object.keys(baseKey);
const barcodeEqualityAttributes = ['key'];

const areKeysEqual = (key1, key2, equalityAttributes) => {
  return equalityAttributes.reduce((isEqual, attribute) => {
    const areAttributesEqual = key1[attribute] === key2[attribute];
    return isEqual && areAttributesEqual;
  }, true);
};

export const isPartialMatch = (inputBuffer, rule) => {
  const hotkeyArray = rule.partialMatch;
  const { length } = inputBuffer;
  let isMatch = null;
  for (let i = 0; i < length; i++) {
    const key = convertKeyToDefaultKeyObject(hotkeyArray[i]);
    if (key.key === '**') {
      isMatch = true;
      break;
    }

    if (key.key === inputBuffer[i].key) {
      if (isMatch === null) {
        isMatch = true;
      } else {
        isMatch = isMatch && true;
      }
    } else {
      isMatch = false;
      break;
    }
  }

  return !!isMatch;
};

export const isCompleteMatch = (inputBuffer, rule) => {
  if (rule.matches !== undefined) {
    return rule.matches(convertInputBufferToString(inputBuffer), inputBuffer);
  }

  return (
    rule.hotkeyArray.length === inputBuffer.length &&
    rule.hotkeyArray.reduce((completeMatch, hotkey, index) => {
      const key = convertKeyToDefaultKeyObject(hotkey);
      const equalityAttributes = rule.barcode ? barcodeEqualityAttributes : hotkeyEqualityAttributes;
      const areEqual = areKeysEqual(key, inputBuffer[index], equalityAttributes);
      return areEqual && completeMatch;
    }, true)
  );
};
